import { StationRequestModel } from "./station.model";

const ACTION_SCOPE = '[Station]';

export class SetFilteredStations {
  static readonly type = `${ACTION_SCOPE} Set Filtered Stations`;
  constructor(public payload: string) { }
}
export class SetStationSearch {
  static readonly type = `${ACTION_SCOPE} Set Search Query`;
  constructor(public query: string | object) { }
}

// Get all Stations action
export class Stations {
  static readonly type = `${ACTION_SCOPE} Get Stations`
}

// Get single Station action
export class Station {
  static readonly type = `${ACTION_SCOPE} Get Station`
  constructor(public payload: string) { }
}

export class GetActivityHistory {
  static readonly type = `${ACTION_SCOPE} Get Activity History`;
  constructor(public payload: {
    trackId: string, stationId: string, scheduleId: string, cohortId: string
  }) { } // payload is the Station ID
}

// Add Create Station action
export class CreateStation {
  static readonly type = `${ACTION_SCOPE} Create Station`;
  constructor(public payload: Omit<StationRequestModel, 'id'>) { }
}

// Add Update Station action
export class UpdateStation {
  static readonly type = `${ACTION_SCOPE} Update Station`;
  constructor(public payload: StationRequestModel) { }
}

// Add Delete Station action
export class DeleteStation {
  static readonly type = `${ACTION_SCOPE} Delete Station`;
  constructor(public payload: string) { }  // payload is the Station ID
}

// Add Assign Station action
export class AssignStation {
  static readonly type = `${ACTION_SCOPE} Assign Station`;
  constructor(public payload: {}) { }  // payload is the Cohort ID
}

// Get single Rotation action
export class Rotation {
  static readonly type = `${ACTION_SCOPE} Get Rotation`
  constructor(public payload: string) { }
}

// Replace Schedule Interviewer action
export class ReplaceScheduleInterviewer {
  static readonly type = `${ACTION_SCOPE} Replace Schedule Interviewer`;
  constructor(public payload: { interviewerId: string; scheduleId: string }) { }
}

// Replace Station Interviewer action
export class ReplaceStationInterviewer {
  static readonly type = `${ACTION_SCOPE} Replace Station Interviewer`;
  constructor(public payload: { oldInterviewerId: string; newInterviewerId: string; stationId: string }) { }
}
